import { DangerButton, IconButton } from 'components/CustomButton'

export const ReferralBanner = ({ mobile = true, preview = true }) => {
  return (
    <div className="w-full app-top-mg app-side-pd bg-none text-dark">
      <div className={`gradient-primary app-rounded flex overflow-hidden justify-between ${mobile ? "px-2.5 pt-2.5 flex-col items-between" : "px-8 pt-5 flex-row items-end referral-content-spacing"}`}>
          <div className="self-center relative max-w-lg">
              <div className="flex justify-between">
                <div className={`flex-1 font-medium text-white mb-5 sm:mb-10 mt-2.5 sm:mt-4 leading-tight whitespace-normal ${mobile ? "text-lg" : "referal-text"}`}>
                Refer a friend and earn
                <span className="font-black"> 1000 Vee Coins</span> upon
                their first order.
                </div>
                {mobile && 
                  <div className="shrink-0">
                    <img
                    className='aspect-[600/965] w-36 shrink-0' 
                    src="/images/refer_friend.png"
                    alt="refer_friend"
                  />
                  </div>
                }              
              </div>
              <div className={mobile ? "absolute left-0 right-0 bottom-0 mb-3.5" : "static mr-4 max-w-lg mb-8"}>
                  <div className="flex justify-between">
                    <div className={`${mobile ? "text-xs" : "text-base"} text-white font-medium mb-1.5`}>Referral Code</div>
                  
                  </div>
                  <div className="border-2 border-primaryApp border-dashed bg-primaryApp-light rounded flex justify-between items-center px-2.5 py-2">
                    <div className={`font-black ${mobile ? "text-base" : "text-lg"}`}>ref1234</div>
                    <div className="flex items-center space-x-0.5"> 
                      <span className={`material-icons select-none leading-none ${mobile ? "text-base" : "text-xl"}`}>content_copy</span>
                      <span className="text-xs sm:text-sm font-medium leading-none sm:leading-none">Copy</span>
                    </div>
                  </div>
                  {mobile && (
                    <div
                    className={`app-rounded bg-primaryApp px-2 py-3 text-sm leading-none flex-1 text-white mt-2.5 text-center`}>
                      Refer Friends
                  </div>
                  )}
              </div>
          </div>
          {!mobile && 
            <div className='shrink-0'>
              <img
              className="refer-friend-web"
              src="/images/refer_friend.png"
              alt="refer_friend"
            />          
            </div>}       
      </div>
    </div>
    
  )
}
